export default __webpack_public_path__ + "static/media/app-achievements-dark.a1e67e96.png";